interface CircleProgressProps {
  value?: number;
  className?: string;
  progressColor?: string;
}

const CircleProgress = ({ value = 0, className = "", progressColor }: CircleProgressProps) => {
  const normalizedValue = Math.min(Math.max(value, 0), 1);
  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - normalizedValue * circumference;

  // Use custom color if provided, otherwise fallback to original logic
  const defaultProgressColor = normalizedValue === 1 ? "#D7E251" : "#024693";
  const strokeColor = progressColor || defaultProgressColor;
  const fillColor = normalizedValue === 1 ? strokeColor : "none";

  return (
    <svg className={className} width="40" height="40" viewBox="0 0 100 100">
      <circle cx="50" cy="50" r={radius} fill={fillColor} stroke="#e0e0e0" strokeWidth="8" />
      <circle
        cx="50"
        cy="50"
        r={radius}
        fill="none"
        stroke={strokeColor}
        strokeWidth="8"
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        transform="rotate(-90 50 50)"
      />
      {normalizedValue === 1 && (
        <polyline
          points="40,55 48,63 62,47"
          fill="none"
          stroke="#fff"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(49,46) scale(1.2) translate(-50,-50)"
        />
      )}
    </svg>
  );
};

export default CircleProgress;
